import type { MessageKey } from "./ru"

export const csMessages = {
  "common.loading": "Načítání...",
  "common.error": "Chyba",
  "common.back": "Zpět",
  "common.next": "Další",
  "common.search": "Hledat",
  "auth.loginErrorTitle": "Chyba přihlášení",
  "auth.openViaTelegram": "Otevřete aplikaci přes Telegram",
  "auth.telegramRequired": "Aplikace musí být otevřena přes Telegram",
  "auth.authorizationError": "Chyba autorizace",
  "device.rotatePortrait": "Otočte zařízení na výšku",
  "country.brazil": "Brazílie",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egypt",
  "country.india": "Indie",
  "country.indonesia": "Indonésie",
  "country.iran": "Írán",
  "country.spain": "Španělsko",
  "country.italy": "Itálie",
  "country.kazakhstan": "Kazachstán",
  "country.colombia": "Kolumbie",
  "country.malaysia": "Malajsie",
  "country.mexico": "Mexiko",
  "country.nigeria": "Nigérie",
  "country.pakistan": "Pákistán",
  "country.russia": "Rusko",
  "country.usa": "Spojené státy",
  "country.turkey": "Turecko",
  "country.uzbekistan": "Uzbekistán",
  "country.ukraine": "Ukrajina",
  "country.philippines": "Filipíny",
  "countrySelection.chooseCountry": "Vyberte zemi",
  "countrySelection.openAria": "Vyberte zemi",
  "languageSelection.chooseLanguage": "Vyberte jazyk",
  "commercial.direction.autotrade": "Auto Market",
  "commercial.direction.insurance": "Pojištění",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Silniční asistence",
  "commercial.searchLabel": "Vyhledávání BeepApp",
  "commercial.cityPlaceholder": "Zadejte město",
  "commercial.emptyTitle": "Dnes nejsou žádné nabídky",
  "commercial.emptyLine1": "Ve vašem městě zatím nejsou aktivní partneři BeepApp",
  "commercial.emptyLine2": "Už pracujeme na jejich vyhledání a připojení",
  "commercial.emptyLine3": "Nové nabídky se zde objeví automaticky",
  "commercial.helperLine1": "Zadejte své město a zobrazte",
  "commercial.helperLine2": "dostupné nabídky",
  "commercial.partnerPrompt": "Chcete se stát partnerem BeepApp?",
  "commercial.apply": "Přihlásit se",
  "main.admin": "Admin",
  "main.garage": "Garáž",
  "main.signalSent": "Signál odeslán",
  "main.partnerInviteUnavailable": "Partnerská pozvánka není dostupná",
  "main.enterPlate": "Zadejte registrační značku",
  "main.searchError": "Chyba vyhledávání",
  "main.signalSendError": "Signál se nepodařilo odeslat",
  "main.shareCardPrefix": "Karta značky",
  "main.shareLinkError": "Odkaz se nepodařilo připravit",
  "main.searchByPlateAria": "Hledat podle registrační značky",
  "main.russianPlateAria": "Ruská registrační značka",
  "main.plateAria": "Registrační značka",
  "main.findPlateAria": "Najít značku",
  "main.loadingVehicle": "Načítání karty vozidla…",
  "main.leaveSignal": "Odeslat signál",
  "main.share": "Sdílet",
  "signalSelection.chooseType": "Vyberte typ signálu",
  "signalSelection.category.attention": "Osobní",
  "signalSelection.category.road": "Silniční",
  "signalSelection.category.urgent": "Naléhavé",
  "signalSelection.chooseSignal": "Vyberte signál",
  "signalSelection.suggestOwn": "Navrhnout vlastní",
  "signalConfirmation.title": "Potvrdit signál",
  "signalConfirmation.plateHeading": "Zkontrolujte registrační značku",
  "signalConfirmation.signalHeading": "Zkontrolujte vybraný signál",
  "signalConfirmation.replyTitle": "Povolit odpověď v Telegramu",
  "signalConfirmation.replyBody": "Zapněte tuto možnost, aby vám majitel značky mohl\nnapsat v Telegramu. Odpověď je možná pouze tehdy,\npokud máte @username. Rozhodnutí odpovědět\nzůstává na majiteli značky.",
  "signalConfirmation.consentText": "Potvrzuji, že tento signál odpovídá\nskutečné situaci a nejde o spam\nani falešné hlášení.",
  "signalConfirmation.warning": "Po odeslání už signál\nnelze změnit",
  "signalConfirmation.sending": "Odesílání…",
  "signalConfirmation.send": "Odeslat",
  "partner.loadingAria": "Načítání",
  "partner.title": "Partnerský program",
  "partner.offerLine1": "Získávejte trvale 30 % ze všech plateb",
  "partner.offerLine2": "uživatelů, které pozvete do BeepApp",
  "partner.offerLine3": "prostřednictvím affiliate programu Telegram",
  "partner.connectUnavailable": "Připojení bude dostupné po nastavení affiliate programu Telegram.",
  "partner.connectTelegram": "Připojit v Telegramu",
  "partner.qrAria": "QR kód partnerského odkazu",
  "partner.download": "Stáhnout",
  "partner.promoHeading": "Vytvořit osobní promo kód",
  "partner.promoHelperLine1": "Promo kód aktivuje další rok předplatného",
  "partner.promoHelperLine2": "a pomáhá získávat uživatele",
  "partner.promoAria": "Promo kód",
  "partner.affiliateHeading": "Váš affiliate odkaz",
  "partner.affiliateHelper": "Uložte odkaz a vytvořte osobní QR kód",
  "partner.affiliateAria": "Affiliate odkaz",
  "partner.qrNoteLine1": "QR kód lze umístit na vaše vozidlo,",
  "partner.qrNoteLine2": "na sociální sítě a do reklamních materiálů",
  "partner.save": "Uložit",
  "partner.reset": "Resetovat",
  "partner.resetConfirm": "Resetovat uložený affiliate odkaz? Promo kód vám zůstane.",
  "partner.promoFormatError": "Promo kód musí mít 4 až 15 znaků.",
  "partner.affiliateHostError": "Povoleny jsou pouze odkazy t.me nebo telegram.me.",
  "partner.affiliatePathError": "Odkaz neobsahuje cestu Telegramu.",
  "partner.affiliateFormatError": "Neplatný affiliate odkaz.",
  "partner.loadError": "Chyba načítání",
  "partner.checkInputError": "Zkontrolujte zadané údaje",
  "garageActivation.promoInvalid": "Promo kód je neplatný",
  "garageActivation.plateOccupied": "Tato registrační značka je již propojena",
  "garageActivation.activateError": "Garáž se nepodařilo aktivovat",
  "garageEntry.loadJournalError": "Palubní deník se nepodařilo načíst",
  "garageEntry.loadStatusesError": "Stavy se nepodařilo načíst",
  "garageEntry.activationSuccess": "Garáž byla úspěšně aktivována",
  "garageEntry.plateAttached": "Značka propojena",
  "garageEntry.attachError": "Značku se nepodařilo propojit",
  "garageEntry.activationNote": "Aktivujte svou Garáž",
  "garageSheet.activationTitle": "Aktivace Garáže",
  "garageSheet.plateHelper": "Zadejte registrační značku vozidla",
  "garageSheet.promoHelper": "Máte promo kód?",
  "garageSheet.cleanBonusLine1": "Po aktivaci máte 1 hodinu",
  "garageSheet.cleanBonusLine2": "na bezplatný „Clean Start“",
  "garageSheet.activationFor": "Aktivace na",
  "garageSheet.cost": "Cena",
  "garageSheet.ownerConsentLine1": "Potvrzuji, že jsem vlastníkem",
  "garageSheet.ownerConsentLine2": "vozidla s uvedenou",
  "garageSheet.ownerConsentLine3": "registrační značkou.",
  "garageSheet.processing": "Zpracování...",
  "garageSheet.attach": "Propojit",
  "garageSheet.pay": "Zaplatit",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Deaktivace Garáže",
  "garageLifecycle.cleanWarningLine1": "Historie značky bude smazána",
  "garageLifecycle.cleanWarningLine2": "bez možnosti obnovení!",
  "garageLifecycle.deactivateWarningLine1": "Po deaktivaci skončí přístup k aktivním",
  "garageLifecycle.deactivateWarningLine2": "funkcím Garáže",
  "garageLifecycle.willBeDeleted": "BUDE SMAZÁNO",
  "garageLifecycle.cleanRemovedLine1": "• Všechny záznamy z palubního deníku",
  "garageLifecycle.cleanRemovedLine2": "• Historie přijatých signálů",
  "garageLifecycle.cleanRemovedLine3": "• Veřejná počítadla signálů",
  "garageLifecycle.cleanRemovedLine4": "  na kartě značky",
  "garageLifecycle.willRemain": "ZŮSTANE ZACHOVÁNO",
  "garageLifecycle.cleanPreservedLine1": "• Propojení značky s Garáží",
  "garageLifecycle.cleanPreservedLine2": "• Zbývající doba aktivace",
  "garageLifecycle.cleanPreservedLine3": "• Vybraný stav značky",
  "garageLifecycle.cleanPreservedLine4": "• Celkový počet zobrazení karty",
  "garageLifecycle.freeFirstHour": "Zdarma během první hodiny",
  "garageLifecycle.willBecomeUnavailable": "PŘESTANE BÝT DOSTUPNÉ",
  "garageLifecycle.deactivateRemovedLine1": "• Palubní deník",
  "garageLifecycle.deactivateRemovedLine2": "• Výběr a použití stavu značky",
  "garageLifecycle.deactivateRemovedLine3": "• Automaticky opustíte AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Auto Market",
  "garageLifecycle.deactivateRemovedLine5": "• Pojištění",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Silniční asistence",
  "garageLifecycle.deactivateRemovedLine8": "• Značka bude odpojena od Garáže",
  "garageLifecycle.willRemainAvailable": "ZŮSTANE DOSTUPNÉ",
  "garageLifecycle.deactivatePreservedLine1": "• Spolujezdec",
  "garageLifecycle.deactivatePreservedLine2": "• Dispečer",
  "garageLifecycle.deactivatePreservedLine3": "• Vyhledávání a prohlížení značky",
  "garageLifecycle.deactivatePreservedLine4": "  veřejné karty vozidla",
  "garageLifecycle.deactivatePreservedLine5": "• Možnost kdykoli znovu",
  "garageLifecycle.deactivatePreservedLine6": "  aktivovat Garáž",
  "garageLifecycle.cleanConsentLine1": "Souhlasím se smazáním",
  "garageLifecycle.cleanConsentLine2": "celé historie této značky",
  "garageLifecycle.cleanConsentLine3": "bez možnosti obnovení.",
  "garageLifecycle.deactivateConsentLine1": "Potvrzuji deaktivaci a",
  "garageLifecycle.deactivateConsentLine2": "ukončení přístupu ke všem",
  "garageLifecycle.deactivateConsentLine3": "aktivním funkcím Garáže.",
  "garageLifecycle.clean": "Vymazat",
  "garageLifecycle.deactivate": "Deaktivovat",
} satisfies Record<MessageKey, string>
